import { getPracticesByIds } from "@frontend/lib/actions/actions";
import type { HrtExtended } from "@frontend/lib/stores/slices/procedureSlice";
import { useQuery } from "@tanstack/react-query";

export const useSelectableLocationDropdown = (hrtList: HrtExtended[]) => {
  const providerGroupsInCart = hrtList.flatMap((hrt: HrtExtended) =>
    hrt?.providerGroupToHrt?.filter(
      (providerGroups) => !providerGroups.notBookable,
    ),
  );

  const activeProviderGroups = providerGroupsInCart.filter(
    (providerGroup) => providerGroup.isActive,
  );

  const providerGroupsInActiveProviderGroup = activeProviderGroups.flatMap(
    (providerGroups) => providerGroups.providerGroup,
  );

  const practiceIdInActiveProviderGroup =
    providerGroupsInActiveProviderGroup.map(
      (providerGroup) => providerGroup?.practiceId,
    );

  const dedupedPracticeIdInActiveProviderGroup = [
    ...new Set(practiceIdInActiveProviderGroup),
  ];

  const { data: practiceData, isPending } = useQuery({
    queryKey: ["getPracticesByIds", dedupedPracticeIdInActiveProviderGroup],
    queryFn: () => getPracticesByIds(dedupedPracticeIdInActiveProviderGroup),
    select: (data) => {
      return data.filter((practice) => practice.isAvailableFromStorefront);
    },
  });

  const formattedLocations = practiceData?.map((data) => ({
    label: `${data.locationName} - ${data.address}`,
    value: data.practiceId.toString(),
    metadata: data.metadata,
    googleMapsEmbed: data.googleMapsEmbed,
    googleMapsUrl: data.googleMapsUrl,
    phoneNumber: data.phoneNumber,
    timeZone: data.timezone,
  }));

  const dedupedLocations = [
    ...new Map(formattedLocations?.map((x) => [x.value, x])).values(),
  ];

  return { dedupedLocations, isPending };
};
